// codePoints will take a string and returns its unicode code points as HTML. This helps us make sure that we can
// properly encode and send non-latin characters to the PDF generator, and for use with base64.
//
// Example:
// Input:   Söder
// output:  &#83;&#246;&#100;&#101;&#114;
const codePoints = function (s) {
  let ret = ''
  for (let i = 0; i < s.length; i++) {
    ret += '&#' + s[i].charCodeAt() + ';'
  }
  return ret
}

export default { codePoints }



// WEBPACK FOOTER //
// ./src/filters/utf8/index.js